import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

function CodeBlock({ language, value }) {
  const [copied, setCopied] = useState(false);
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  
  return (
    <div className="relative rounded-md overflow-hidden my-4 border border-gray-200">
      <div className="flex items-center justify-between bg-gray-800 px-4 py-2 text-gray-200">
        <div className="text-xs font-medium">{language}</div>
        <button
          onClick={copyToClipboard}
          className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded transition-colors"
        >
          {copied ? 'Copied!' : 'Copy code'}
        </button>
      </div>
      <SyntaxHighlighter
        language={language}
        style={atomDark}
        customStyle={{ margin: 0, borderRadius: '0 0 0.375rem 0.375rem' }}
      >
        {value}
      </SyntaxHighlighter>
    </div>
  );
}

export default CodeBlock;

